/** @type {"deviate"} */
export const DEVIATE = "deviate";
/** @type {"merge"} */
export const MERGE = "merge";
/** @type {"split"} */
export const SPLIT = "split";
/** @type {"style"} */
export const STYLE = "style";
/** @type {"forceMerge"} */
export const FORCE_MERGE = "forceMerge";

export const PROCESSES = [DEVIATE, FORCE_MERGE, MERGE, SPLIT, STYLE];